import { createSlice } from '@reduxjs/toolkit';
import { IAction } from '../store';

type DndIntent = 'documentCategorization' | 'fileUpload';

export interface IDragDropState {
    dndActive: boolean;
    dndIntent: DndIntent | null;
}

const initialState: IDragDropState = {
    dndActive: false,
    dndIntent: null,
};

const reducers = {
    setDndActive(state: IDragDropState, action: IAction<DndIntent | false>) {
        if (!action.payload) {
            state.dndActive = false;
            state.dndIntent = null;
            return;
        }

        state.dndActive = true;
        state.dndIntent = action.payload;
    },
};

export const dragDropSlice = createSlice({
    name: 'dragDrop',
    initialState,
    reducers,
});

export const { setDndActive } = dragDropSlice.actions;

export default dragDropSlice.reducer;
